var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "span",
    [
      !_vm.inContacting || _vm.waitingForAcceptance
        ? _c("JonInfo", {
            scopedSlots: _vm._u(
              [
                {
                  key: "message",
                  fn: function() {
                    return [
                      _c(
                        "div",
                        {
                          staticClass:
                            "d-flex align-items-center flex-column flex-md-row"
                        },
                        [
                          _c("div", { staticClass: "flex-grow-1 mr-2" }, [
                            _c("div", { staticClass: "font-weight-bold" }, [
                              _vm._v("Klingt gut für dich?")
                            ]),
                            _vm._v(" "),
                            _vm.waitingForAcceptance
                              ? _c("div", [
                                  _vm._v(
                                    "Dann akzeptiere die Anfrage des Kandidaten so schnell wie möglich!"
                                  )
                                ])
                              : _c("div", [
                                  _vm._v(
                                    "Dann melde dich schnell bei dem Kandidaten!"
                                  )
                                ])
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "mt-4 mt-md-0" },
                            [
                              _vm.waitingForAcceptance
                                ? _c("Button", {
                                    attrs: {
                                      text: "Kontaktanfrage annehmen",
                                      icon: "checkmark"
                                    },
                                    on: { click: _vm.onAcceptRequest }
                                  })
                                : _c("Button", {
                                    attrs: {
                                      icon: "checkmark",
                                      text: "Jetzt kontaktieren",
                                      primary: true
                                    },
                                    on: { click: _vm.onClick }
                                  })
                            ],
                            1
                          )
                        ]
                      )
                    ]
                  },
                  proxy: true
                }
              ],
              null,
              false,
              87302953
            )
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }